import { gql } from "@apollo/client";

export const MY_PROCESSING = gql`
  query Query($userFeed: Boolean, $montages: Boolean) {
    myProcessing(userFeed: $userFeed, montages: $montages) {
      userFeed
      montages
    }
  }
`;
